module.exports = __webpack_public_path__ + "static/human_female_bard_SCAG-d7e21dbe482f0459f003a959fb075cb6.png";